import { v1ApiClient } from '@/services';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

export const createSearchWithChart = async (
  params: ChartFeedbackListModalOptions<
    AllFeedbackListModalOptions | CellFeedbackListModalOptions
  >,
): Promise<GlobalSearchResult> => {
  const wa = getCurrWorkspaceAlias();
  const res = await v1ApiClient.post(
    `/workspaces/${wa}/charts/search`,
    params,
  );
  return res.data;
};
